// extracted by mini-css-extract-plugin
export var depositDetails = "InterestCalculator-module--depositDetails--3f8c2";
export var depositDetails_amount = "InterestCalculator-module--depositDetails_amount--b3482";
export var depositDetails_label = "InterestCalculator-module--depositDetails_label--aaa7f";
export var interestCalculator = "InterestCalculator-module--interestCalculator--73ca9";
export var interestCalculator_additional_info = "InterestCalculator-module--interestCalculator_additional_info--a09dd";
export var interestCalculator_amount_labels = "InterestCalculator-module--interestCalculator_amount_labels--3e4e5";
export var interestCalculator_error = "InterestCalculator-module--interestCalculator_error--3a114";
export var interestCalculator_table_data = "InterestCalculator-module--interestCalculator_table_data--316d8";
export var interestCalculator_title = "InterestCalculator-module--interestCalculator_title--7b0a4";
export var interestCalculator_wrapper = "InterestCalculator-module--interestCalculator_wrapper--7d3f1";
export var lgBreak = "1200";
export var mdBreak = "992";
export var smBreak = "768";
export var xsBreak = "480";